import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-pagamenti-importazione-file',
  templateUrl: './pagamenti-importazione-file.component.html',
  styleUrls: ['./pagamenti-importazione-file.component.css']
})
export class PagamentiImportazioneFileComponent extends AppComponentGenericComponent implements OnInit {
	uploader: FileUploader;
	url = 'api/importa_pratiche';

	constructor(protected dataService: DataService) {
		super(dataService, 'pagamenti-importazione-file');
		this.uploader = new FileUploader({url: this.url });
		this.uploader.onCompleteAll = () => {
			console.log("ok");
		};
	}

	ngOnInit() {
	}

	removeFiles(){
		this.uploader.clearQueue();
	}

	uploadFiles(){
		this.uploader.uploadAll();
	}
}
